<template>
  <div class="bottom">
    <div>
      <div :class="[langShow?'':'bottomContEn','bottomCont']">
        <div><img class="logo" src="../../assets/logo_footer.png" alt="" /></div>
        <div>{{ $i18.language('外贸资讯宝GT6.0') }}</div>
      </div>
      <p>
        {{ $i18.language('© 特易资讯 版权所有') }} 
        <span class="go-home"><a :href="langShow ? 'https://et.topease.net/e_policy.html' : 'https://et.topease.net/e_policyEn.html'">{{ $i18.language('用户协议') }}</a></span>
        <span class="go-home"> <a :href="langShow ? 'https://et.topease.net/policy.html' : 'https://et.topease.net/policyEn.html'">{{ $i18.language('隐私条款') }}</a></span>
      </p>
      <p v-if='langShow'>备案号：沪ICP备09080027号 <span>沪公网安备 31010402007884号</span></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footerCont',

  data() {
    return {
      langShow: localStorage.getItem('language') == 'en' ? false : true,
    }
  },

  mounted() {},

  methods: {
    goHome() {
      this.$router.push('/home')
    },
  },
}
</script>

<style lang="scss" scoped>
.go-home {
  cursor: pointer;
}
.bottom {
  border-top: 1px solid #dedede;
  border-bottom: 1px solid #dedede;
  padding: 24px 0 10px;
  color: rgba(255, 255, 255, 0.6);
  // border-top: 2px solid rgba(255, 255, 255, 0.2);
  > div {
    max-width: 1100px;
    margin: 0 auto;
    text-align: center;
    p {
      margin-bottom: 15px;
      font-size: 14px;
      color: #999999;
      a {
        color: #999999;
        text-decoration: none;
      }
      span {
        margin-left: 15px;
      }
    }
    .bottomCont {
      width: 220px;
      margin: 0 auto;
      font-size: 14px;
      color: #999999;
      display: flex;
      margin-bottom: 15px;
      justify-content: space-around;
    }
    .bottomCont > div:nth-child(2) {
      line-height: 28px;
    }
    .bottomContEn{
        width: 256px;
    }
  }

  .logo {
    width: 76px;
  }
}
</style>